import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { DataSourcesEnum } from 'src/app/enums/DataSourcesEnum';
import { ElectionService } from 'src/app/services/election.service';
import { startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.scss']
})
export class CountDownComponent implements AfterViewInit {

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();
  private countDownTimer: any;
  


  public seconds = 0;
  public minutes = 0;
  public hours = 0;
  public days = 0;

  constructor(
    public electionService: ElectionService, 
    private changeDetectorRef: ChangeDetectorRef
  ) { 
    this.electionService.dataLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(dataLoaded => {
      if (dataLoaded.dataSource === DataSourcesEnum.ElectionDates) {
        this.countDownToElection();
      }
    });
    this.electionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(page => {
      this.countDownToElection();
    });
  }

  
  ngAfterViewInit() {
    if (this.electionService.electionDates.length > 0) {
      this.countDownToElection();
      this.changeDetectorRef.detectChanges();
    }

  }


  private countDownToElection(): void {
    this.countDownTimer = interval(1000)
      .pipe(
        startWith(0)
      )
    .subscribe(() => {
      if (this.electionService.isCountingStarted===false) {   // TODO
        const currentDate = new Date();
        const targetDate = this.electionService.startCountDateTime ?? new Date();  // TODO
        const cDateMillisecs = currentDate.getTime();
        const tDateMillisecs = targetDate.getTime();
        const difference = tDateMillisecs - cDateMillisecs;
        if (difference < 0) {
          this.electionService.countDownComplete();
        }
        this.seconds = +Math.floor(difference / 1000);
        this.minutes = +Math.floor(this.seconds / 60);
        this.hours = +Math.floor(this.minutes / 60);
        this.days = +Math.floor(this.hours / 24);
    
        this.hours %= 24;
        this.minutes %= 60;
        this.seconds %= 60;
      }
    });
  }
    
}
